(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('AttachmentsComponentController', AttachmentsComponentController);

    AttachmentsComponentController.$inject = ['$scope'];

    function AttachmentsComponentController($scope) {
        var vm = this;

        vm.init = init();

        function init() {
            console.log('========= ATTACHMENTS =========');
        }
    }
})();
